import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "move_to_active",
  "use": "move_to_active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"move_to_active\"><g fill-rule=\"evenodd\"><path d=\"M15.333 13 12 9v8h4c.556 0 1-.448 1-1v-3h-1.667ZM0 7h12v10H1.002A1.005 1.005 0 0 1 0 16.005V7Z\" opacity=\".9\" /><path d=\"M0 7h12v1H0z\" /><path d=\"M0 3h6l2 2v2H0V3Zm8 2h7v2H8V5Z\" opacity=\".6\" /><path d=\"M17 9.929 18.688 8H20l-3.5 4L13 8h1.313L16 9.929V3h1v6.929Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol